import { skills } from "./SkillsText";
import eazyPassImage from "../images/Projects/EazyPass.jpeg";

import blissdistro from "../images/Projects/blissdistro.png";
import digiasset from "../images/Projects/digitalmarket.png";
import petrahouse from "../images/Projects/petrahouse.png";

import shippingTracker from "../images/Projects/shippingTracker.jpeg";
export const projects = [
  {
    id: 1,
    name: "Digiassets",
    description:
      "A platform to sell and buy digital assets such as social media accounts and or any digital assets",
    image: digiasset,
    link: "https://digitalmarketsquare.com/",
    techStacks: [
      { name: "HTML5", icon: skills.HTML5 },
      { name: "Tailwind", icon: skills.Tailwind },
      { name: "Javascript", icon: skills.Javascript },
      { name: "React", icon: skills.React },
      { name: "Zusatand", icon: skills.Zustand },
      { name: "Nodejs", icon: skills.NodeJS },
      { name: "MongoDB", icon: skills.MongoDB },
    ],
  },
  {
    id: 2,
    name: "House Of Petra",
    description:
      "A platoform built for church to manage their image gallery, events as well as keeping the chronicles of the church general overseers.",
    image: petrahouse,
    link: "https://petrahouse.vercel.app/",
    techStacks: [
      { name: "HTML5", icon: skills.HTML5 },
      { name: "CSS3", icon: skills.CSS3 },
      { name: "JavaScript", icon: skills.Javascript },
      { name: "NextJs", icon: skills.NextJs },
      { name: "PostgressSQL", icon: skills.postgressSQL },
      { name: "GCP", icon: skills.GoogleCloud },
    ],
  },
  {
    id: 2,
    name: "Eazypass",
    description:
      "A Practice ground with thousands of questions for who desires to take exams. It contains various fields from SSCE to IT Computers",
    image: eazyPassImage,
    link: "https://eazy-pass.vercel.app",
    techStacks: [
      { name: "HTML5", icon: skills.HTML5 },
      { name: "CSS3", icon: skills.CSS3 },
      { name: "JavaScript", icon: skills.Javascript },
      { name: "Nodejs", icon: skills.NodeJS },
    ],
  },
  {
    id: 3,
    name: "Blissdistro",
    description:
      "A music distribution platform to aid upcoming artistes gain followers and manage thier fan base and share their music easily with fans and families",
    image: blissdistro,
    link: "https://blissdistro.vercel.app",
    techStacks: [
      { name: "HTML5", icon: skills.HTML5 },
      { name: "Tailwind", icon: skills.Tailwind },
      { name: "JavaScript", icon: skills.Javascript },
      { name: "React", icon: skills.React },
      { name: "Redux", icon: skills.Redux },
      { name: "NodeJs", icon: skills.NodeJS },
      { name: "ExpressJs", icon: skills.ExpressJs },
      { name: "MongoDB", icon: skills.MongoDB },
    ],
  },
  {
    id: 3,
    name: "Shipping Tracker",
    description:
      "A Tracking mock for shipping company to update their client on vital information concerning the shipment ",
    image: shippingTracker,
    link: "https://ezyprojects.000webhostapp.com/shipmenttracker",
    techStacks: [
      { name: "HTML5", icon: skills.HTML5 },
      { name: "CSS3", icon: skills.CSS3 },
      { name: "Boostrap", icon: skills.Boostrap },
      { name: "JavaScript", icon: skills.Javascript },
      { name: "PHP", icon: skills.PHP },
      { name: "MySQLi", icon: skills.MySQLi },
    ],
  },
];
